// service for send out admin invite email
export const sendAdminInvite = async (apiInstance, email) => {
  try {
    const response = await apiInstance.post("/admin/invite", { email });
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

// service for send out admin invite email at coach

export const sendAdminInviteCoach = async (apiInstance, email) => {
  try {
    const response = await apiInstance.post("/admin/invite-coach", { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error("An error occurred");
  }
};

// verifyng registrering an admin
export const registerAdmin = async (apiInstance, data) => {
  try {
    const response = await apiInstance.post("/admin/register", data);
    return response.data;
  } catch (err) {
    console.error("Error registering admin:", err);
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

// services for searching admins
export async function SearchAdminByParams(apiInstance, query) {
  try {
    const response = await apiInstance.get(`/Admin/search?q=${query}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

// updating password user
export const updatePassword = async (
  apiInstance,
  currentPassword,
  newPassword,
  repeatPassword,
) => {
  try {
    const response = await apiInstance.put("/user/password", {
      currentPassword,
      newPassword,
      repeatPassword,
    });
    return response.data;
  } catch (err) {
    throw err.response ? err.rresponse.data : new Error("An error ocurred");
  }
};
// service update-Athlete-Password
export const updateAthletePassword = async (
  apiInstance,
  userId,
  newPassword,
) => {
  try {
    const response = await apiInstance.put(
      `/admin/athlete-password/${userId}`,
      {
        password: newPassword,
      },
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

// service admin-deactivate
export const adminDeactivate = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/admin/deactivate/${userId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

// services for gettting prices
export const getPricing = async (apiInstance) => {
  try {
    const response = await apiInstance.get("/Admin/pricing-options");
    return response.data;
  } catch (error) {
    console.error("Error getting prices:", error);
    throw error;
  }
};

//services para updating prices
export const updatePricingOptions = async (apiInstance, pricingOptions) => {
  try {
    const { data } = await apiInstance.post("/Admin/pricing-options", {
      pricingOptions,
    });
    return data;
  } catch (error) {
    console.error("Error updating pricing options:", error.message);
    throw error;
  }
};

// service to update jersey number
export const updateJerseyNumber = async (
  apiInstance,
  eventId,
  userId,
  jerseyNumber,
) => {
  try {
    const response = await apiInstance.post(
      `/combine/jersey-number/${eventId}/${userId}?jerseyNumber=${jerseyNumber}`,
    );
    return response;
  } catch (error) {
    const backend = error.response?.data;

    const message =
      backend?.error ||
      backend?.message ||
      backend?.detail ||
      backend?.msg ||
      (typeof backend === "string" ? backend : null) ||
      "An unexpected error occurred.";

    throw message;
  }
};

export const updateProfilePhoto = async (apiInstance, userAthleteId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await apiInstance.post(
      `/FilesStorage/athlete-profile-photo/${userAthleteId}`,
      formData,
    );
    return response.data;
  } catch (error) {
    throw new Error("Error updating profile photo: " + error.message);
  }
};

// services for gettting AllCoupons
export const getAllCoupons = async (apiInstance) => {
  try {
    const response = await apiInstance.get("/Admin/Coupon/all");
    return response.data;
  } catch (error) {
    console.error("Error getting Coupons:", error);
    throw error;
  }
};

//services for adding coupon
export const addCoupon = async (apiInstance, couponObject) => {
  try {
    const data = await apiInstance.post(`/Admin/Coupon`, couponObject);
    return data;
  } catch (error) {
    console.error("Error adding coupon options:", error.message);
    throw error;
  }
};

//services for updating coupon
export const updateCoupon = async (apiInstance, id, couponObject) => {
  try {
    const { data } = await apiInstance.put(`/Admin/Coupon/${id}`, couponObject);
    return data;
  } catch (error) {
    console.error("Error updating coupon options:", error.message);
    throw error;
  }
};

//services for delete coupon
export const deleteCoupon = async (apiInstance, id) => {
  try {
    const { data } = await apiInstance.delete(`/Admin/Coupon/${id}`);
    return data;
  } catch (error) {
    console.error("Error delete coupon options:", error.message);
    throw error;
  }
};

// global
export const getGlobalSetting = async (apiInstance, key) => {
  const response = await apiInstance.get(`/Admin/globalsettings/${key}`);
  return response.data;
};

export const updateGlobalSetting = async (apiInstance, key, value) => {
  const response = await apiInstance.put(`/Admin/globalsettings/${key}`, {
    value,
  });
  return response.data;
};

export const getAdminProfile = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/Admin/profile/${userId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getCandidateAthletes = async (
  apiInstance,
  page = 1,
  pageSize = 25,
) => {
  try {
    const response = await apiInstance.get(
      `/Admin/candidate-athletes?page=${page}&pageSize=${pageSize}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const sendBulkAthleteEmail = async (
  apiInstance,
  subject,
  body,
  UserIds,
) => {
  try {
    const payload = {
      subject: subject?.trim(),
      body,
      UserIds,
    };

    const res = await apiInstance.post("/Admin/athletes/bulk-email", payload);
    return res.data;
  } catch (err) {
    throw err.response ? err.response.data : err;
  }
};
